let googleMapsPromise = null;

export const loadGoogleMapsGlobally = () => {
  if (googleMapsPromise) return googleMapsPromise;

  googleMapsPromise = new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places&v=weekly&loading=async`;
    script.async = true;
    script.defer = true;

    script.onload = resolve;
    script.onerror = reject;

    document.body.appendChild(script);
  });

  return googleMapsPromise;
};
